<template>
    <div class="container-fluid">
        <div class="admin-page text-center">
            <div class="admin-header">
                <h2 class="title">Estados</h2>
                <div class="add-user">
                    <button class="btn btn-secondary" type="button" @click="this.modalToShow = 'add-status'"
                            title="Nuevo estado">
                        <span>Añadir estado</span>
                    </button>
                </div>
            </div>

            <div class="admin-main">
                <v-table>
                    <template v-slot:header>
                        <th class="fit">#</th>
                        <th>Nombre</th>
                        <th>Observaciones</th>
                        <th>Fecha</th>
                        <th class="fit">Acciones</th>
                    </template>

                    <template v-slot:body>
                        <tr v-for="status in statuses">
                            <td class="fit">{{ status.id }}</td>
                            <td>{{ status.name }}</td>
                            <td>{{ status.extra_data }}</td>
                            <td>{{ status.data }}</td>
                            <td class="fit">
                                <div class="actions-container">
                                    <button class="btn btn-secondary" @click="showLawyer(status.id)">
                                        <i class="uq-icon bi-eye"></i>
                                    </button>
                                    <button class="btn btn-warning" @click="editLawyer(status.id)">
                                        <i class="uq-icon bi-pencil"></i>
                                    </button>
                                    <button class="btn btn-danger" @click="deleteLawyer(status)">
                                        <i class="uq-icon bi-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-table>

                <div v-if="statusApp === 'loading'">
                    <div class="loader-container">
                        <div class="loader"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--  <v-show-lawyer v-if="modalToShow === 'show-lawyer'" :lawyerId="lawyerId" @close="this.modalToShow = null"></v-show-lawyer>
      <v-edit-lawyer v-if="modalToShow === 'edit-lawyer'" :lawyerId="lawyerId" @close="this.modalToShow = null; getLawyers()"></v-edit-lawyer>
      <v-delete-lawyer v-if="modalToShow === 'delete-lawyer'" :lawyer="lawyer" @close="this.modalToShow = null; getLawyers()"></v-delete-lawyer>
    -->
    <v-add-status v-if="modalToShow === 'add-status'" @close="this.modalToShow = null; getStatuses()"></v-add-status>
</template>
<script>
/*
import VShowLawyer from "./layouts/ShowLawyer";
import VEditLawyer from "./layouts/EditLawyer";
import VDeleteLawyer from "./layouts/DeleteLawyer";
*/
import VAddStatus from "./parts/StatusesListAddModal";
import {getStatuses} from "../../helpers/requests/RequestsStatuses";
import VTable from "../general/VTable";

export default {
    name: "statuses",
    /*  components: {VShowLawyer, VEditLawyer, VDeleteLawyer, VAddLawyer},*/
    components: {VTable, VAddStatus},
    data() {
        return {
            statusApp: 'loading',
            statuses: [],
            status: null,
            statusId: null,
            modalToShow: null
        }
    },
    mounted() {
        this.getStatuses();
    },
    methods: {
        async getStatuses() {
            try {
                this.statuses = await getStatuses();
                this.statusApp = 'loaded';

            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al cargar los estados');
            }
        },
        showLawyer(id) {
            this.modalToShow = 'show-lawyer';
            this.lawyerId = id;
        },
        editLawyer(id) {
            this.modalToShow = 'edit-lawyer';
            this.lawyerId = id;
        },
        deleteLawyer(lawyer) {
            this.modalToShow = 'delete-lawyer';
            this.lawyer = lawyer;
        },
        addStatus() {
            this.modalToShow = 'add-status';
        }
    }
}
</script>
